export default __webpack_public_path__ + "images/48f40d5e70715da430eec115856c624a-poverty.webp";